import React from 'react';
import { Typography } from '../design-system/typography';

interface SubsectionHeaderProps {
  title: string;
}

export const SubsectionHeader: React.FC<SubsectionHeaderProps> = ({ title }) => {
  return (
    <Typography variant="h3" as="h3">
      {title}
    </Typography>
  );
};